// @ts-nocheck

import React, { FunctionComponent } from 'react'
import { Box, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  progressBar: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}))

const ProgressBar: FunctionComponent = () => {
  const classes = useStyles()

  return (
    <Box className={classes.progressBar}>
      <CircularProgress />
    </Box>
  )
}

export default ProgressBar
